import { Component } from '@angular/core';
import SlotService from '../../cart-process/slot.service';
import { AccessorySecondPageModel } from '../../models/accessory-second-page.model';
import {
  NotificationProviderService,
  NotificationProviderTypeEnum
} from '../../external-interfaces/notification-provider.service';
import { combineLatest } from 'rxjs';

@Component({
  selector: 'order-details-accessory',
  templateUrl: './order-details-accessory.component.html',
})
export class OrderDetailsAccessoryComponent {
  public showSection: boolean = false;
  public accessorySlot: Array<AccessorySecondPageModel> = [];
  public showSectionHeader = false;

  constructor(
    private slotService: SlotService,
    private notificationProvider: NotificationProviderService
  ) {

    combineLatest(
      this.notificationProvider.getSubject(NotificationProviderTypeEnum.SLOTS_SERVICE),
      this.notificationProvider.getSubject(NotificationProviderTypeEnum.COMMON_INFO)
    ).subscribe( (_context: any) => {

      let [_slotService, _commonInfo]: any = _context;

      if (!_slotService || !_commonInfo) {
        return;
      }

      const list: any = _slotService.accessories;
      this.showSection = !!list.length;
      this.showSectionHeader = this.showSection && !_commonInfo.isOtherSalesOffer;
      this.accessorySlot = list;

    });
  }

}
